export default class UtilArray{

    static chunk(lista = [], chunks = 1){

        let chunkArray = [];
        while (lista.length) {
            chunkArray.push(lista.splice(0, chunks));
        }
        return chunkArray;

    }

    static isEmpty(array = []){
        return array.length == 0 ? true : false
    }

    static isNotEmpty(array = []){
        return array.length > 0 ? true : false
    }

    static unique(array=[]){
        return [...new Set(array)];
    }

    static getLast(array=[]){
        return array[array.length-1];
    }

    static clone = (array = []) => {

        return array.map(any => {return {...any}});

    }

    static removeList = (array = [], valuesToRemove = []) => {

        return array.filter(item => !valuesToRemove.includes(item));

    }

    /**
     * Verifica se o array contém o valor informado (===)
     * @param {Array} array - Array a ser verificado
     * @param {*} value - Valor a ser procurado
     * @returns {boolean}
     */
    static includes(array = [], value) {
        return array.includes(value);
    }

    /**
     * Verifica se o array NÃO contém o valor informado (===)
     * @param {Array} array - Array a ser verificado
     * @param {*} value - Valor a ser procurado
     * @returns {boolean}
     */
    static notIncludes(array = [], value) {
        return !array.includes(value);
    }

    /**
     * Verifica se o array contém apenas um valor (===), ignorando falsy/undefined/null para o array.
     * @param {Array} arr - Array a ser verificado
     * @param {*} value - Valor a ser comparado
     * @returns {boolean}
     */
    static hasOnly(arr=[], value="") {
        if (!Array.isArray(arr)) return false;
        return arr.length === 1 && arr[0] === value;
    }

    static concat(...arrays) {

        return [].concat(...arrays);

    }

}